/** @jsxImportSource @emotion/react */

export const UI_VERSION = "5.3.2";

export default function Version({ customCss }) {
  return (
    <div
      css={{
        ...customCss
      }}
    >
      V {UI_VERSION}
    </div>
  );
}
